import React from 'react';
import { cn } from '../../lib/utils';
import { Slot } from '@radix-ui/react-slot';

export function Button({
  variant = 'secondary',
  size = 'md',
  asChild = false,
  children,
  className = '',
  ...props
}) {
  const Component = asChild ? Slot : 'button';

  const baseStyles =
    'inline-flex items-center justify-center font-medium rounded-md transition-colors cursor-pointer focus-visible:outline-none focus-visible:shadow-[var(--focus-ring)] disabled:opacity-50 disabled:pointer-events-none';

  const variantStyles = {
    primary:
      'bg-[var(--fg-primary)] text-[var(--bg-canvas)] hover:opacity-90 active:opacity-100',
    secondary:
      'bg-[var(--bg-elevated)] text-[var(--fg-primary)] shadow-[var(--shadow-sm)] hover:bg-[var(--bg-hover)]',
    ghost:
      'bg-transparent text-[var(--fg-secondary)] hover:text-[var(--fg-primary)] hover:bg-[var(--bg-hover)]',
  };

  const sizeStyles = {
    sm: 'h-8 px-3 text-xs',
    md: 'h-10 px-4 text-sm',
    lg: 'h-12 px-6 text-base',
  };

  const selectedVariant = variantStyles[variant] || variantStyles.secondary;
  const selectedSize = sizeStyles[size] || sizeStyles.md;

  return (
    <Component
      // cn(), not template concatenation: with a plain string both rounded-md
      // and a caller's rounded-full survive into the class list, and stylesheet
      // order decides the winner rather than the caller. That is why the
      // chatbot launcher rendered as a 6px square instead of a circle.
      className={cn(baseStyles, selectedVariant, selectedSize, className)}
      {...props}
    >
      {children}
    </Component>
  );
}

export default Button;
